module.exports = __webpack_public_path__ + "img/error.07db7dfe.svg";